/* eslint-disable default-param-last */
import { sessionConstants } from './creator';

export const sessionModuleInitialState = {
  user: {},
};

const MAPPED_REDUCERS = {

  [sessionConstants.SET_SESSION_DATA]: (state, { payload }) => ({
    ...state,
    ...payload,
  }),

};

function sessionReducer(state = sessionModuleInitialState, action) {
  const handler = MAPPED_REDUCERS[action.type];

  return handler ? handler(state, action) : state;
}

export default sessionReducer;
